import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { SystemLink } from '@app/modules/quick-links/models/quick-links.model';
import { QuickLinksService } from '@app/modules/quick-links/services/quick-links.service';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-system-links-dropdown',
  templateUrl: './system-links-dropdown.component.html',
  styleUrls: ['./system-links-dropdown.component.scss']
})
export class SystemLinksDropdownComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  options: Observable<PagedData<SystemLink>>;

  constructor(
    private quickLinksService: QuickLinksService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.quickLinksService.getAllSystemLinks())
  }

}
